import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  id: string;
};

export async function getWarehouseItemsApi({ id }: Data) {
  return makeRequest(Service.getWarehouseInventory(id, await identify()));
}
